import * as PropTypes from 'prop-types'

export const REDUCER_KEY = 'transactions'

const ACCOUNT_TYPE_REPAYMENT = 'REPAYMENT'
const ACCOUNT_TYPE_BILLING = 'BILLING'

const PRODUCT_TYPE_BF = 'BUYER_FINANCING'
const PRODUCT_TYPE_SF = 'SELLER_FINANCING'

export const productTypeMap = {
  [PRODUCT_TYPE_BF]: 'BF',
  [PRODUCT_TYPE_SF]: 'SF',
}

export const accountTypeMap = {
  [ACCOUNT_TYPE_BILLING]: 'Billing',
  [ACCOUNT_TYPE_REPAYMENT]: 'Transaction',
}

export const accountConfigShape = {
  accountTypes: PropTypes.arrayOf(PropTypes.oneOf([ACCOUNT_TYPE_REPAYMENT, ACCOUNT_TYPE_BILLING]))
    .isRequired,
  productType: PropTypes.oneOf([PRODUCT_TYPE_BF, PRODUCT_TYPE_SF]).isRequired,
}
